import { remappedNames } from '../../../beta/modules/Contacts/MyLeadsFiltersPanel/helpers';

export const getFormattedDisplayValue = (
  systemValue: string | string[] | object[] | boolean,
) => {
  if (Array.isArray(systemValue)) {
    return systemValue
      .map((value: string | object) => {
        if (typeof value === 'object') {
          return Object.entries(value)
            .map(
              ([key, value]: [string, string]) =>
                `${remappedNames(key).friendlyName}: ${value}`,
            )
            .join(', ');
        }
        return value;
      })
      ?.toString();
  }
  return typeof systemValue === 'string'
    ? systemValue?.split('::').pop() || ''
    : systemValue?.toString();
};
